'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../../index');

var _index2 = _interopRequireDefault(_index);

var _dispatcher = require('../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _matrixJsSdk = require('matrix-js-sdk');

var _ratelimitedfunc = require('../../ratelimitedfunc');

var _ratelimitedfunc2 = _interopRequireDefault(_ratelimitedfunc);

var _GroupAddressPicker = require('../../GroupAddressPicker');

var _GroupStore = require('../../stores/GroupStore');

var _GroupStore2 = _interopRequireDefault(_GroupStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RightPanel = function (_React$Component) {
    (0, _inherits3.default)(RightPanel, _React$Component);
    (0, _createClass3.default)(RightPanel, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                roomId: _react2.default.PropTypes.string, // if showing panels for a given room, this is set
                groupId: _react2.default.PropTypes.string, // if showing panels for a given group, this is set
                user: _react2.default.PropTypes.object
            };
        }
    }, {
        key: 'contextTypes',
        get: function get() {
            return {
                matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient)
            };
        }
    }]);

    function RightPanel(props, context) {
        (0, _classCallCheck3.default)(this, RightPanel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RightPanel.__proto__ || (0, _getPrototypeOf2.default)(RightPanel)).call(this, props, context));

        _this.state = {
            phase: _this._getPhaseFromProps(),
            isUserPrivilegedInGroup: null
        };
        _this.onAction = _this.onAction.bind(_this);
        _this.onRoomStateMember = _this.onRoomStateMember.bind(_this);
        _this.onGroupStoreUpdated = _this.onGroupStoreUpdated.bind(_this);
        _this.onInviteToGroupButtonClick = _this.onInviteToGroupButtonClick.bind(_this);
        _this.onAddRoomToGroupButtonClick = _this.onAddRoomToGroupButtonClick.bind(_this);

        _this._delayedUpdate = new _ratelimitedfunc2.default(function () {
            _this.forceUpdate();
        }, 500);
        return _this;
    }

    (0, _createClass3.default)(RightPanel, [{
        key: '_getPhaseFromProps',
        value: function _getPhaseFromProps() {
            if (this.props.groupId) {
                return RightPanel.Phase.GroupMemberList;
            } else if (this.props.user) {
                return RightPanel.Phase.RoomMemberInfo;
            } else {
                return RightPanel.Phase.RoomMemberList;
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.dispatcherRef = _dispatcher2.default.register(this.onAction);
            var cli = this.context.matrixClient;
            cli.on("RoomState.members", this.onRoomStateMember);
            this._initGroupStore(this.props.groupId);
            if (this.props.user) {
                this.setState({ member: this.props.user });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _dispatcher2.default.unregister(this.dispatcherRef);
            if (this.context.matrixClient) {
                this.context.matrixClient.removeListener("RoomState.members", this.onRoomStateMember);
            }
            this._unregisterGroupStore(this.props.groupId);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (newProps.groupId !== this.props.groupId) {
                this._unregisterGroupStore(this.props.groupId);
                this._initGroupStore(newProps.groupId);
            }
        }
    }, {
        key: '_initGroupStore',
        value: function _initGroupStore(groupId) {
            if (!groupId) return;
            _GroupStore2.default.registerListener(groupId, this.onGroupStoreUpdated);
        }
    }, {
        key: '_unregisterGroupStore',
        value: function _unregisterGroupStore() {
            _GroupStore2.default.unregisterListener(this.onGroupStoreUpdated);
        }
    }, {
        key: 'onGroupStoreUpdated',
        value: function onGroupStoreUpdated() {
            this.setState({
                isUserPrivilegedInGroup: _GroupStore2.default.isUserPrivileged(this.props.groupId)
            });
        }
    }, {
        key: 'onInviteToGroupButtonClick',
        value: function onInviteToGroupButtonClick() {
            var _this2 = this;

            (0, _GroupAddressPicker.showGroupInviteDialog)(this.props.groupId).then(function () {
                _this2.setState({
                    phase: RightPanel.Phase.GroupMemberList
                });
            });
        }
    }, {
        key: 'onAddRoomToGroupButtonClick',
        value: function onAddRoomToGroupButtonClick() {
            var _this3 = this;

            (0, _GroupAddressPicker.showGroupAddRoomDialog)(this.props.groupId).then(function () {
                _this3.forceUpdate();
            });
        }
    }, {
        key: 'onRoomStateMember',
        value: function onRoomStateMember(ev, state, member) {
            if (member.roomId !== this.props.roomId) {
                return;
            }
            // redraw the badge on the membership list
            if (this.state.phase === RightPanel.Phase.RoomMemberList && member.roomId === this.props.roomId) {
                this._delayedUpdate();
            } else if (this.state.phase === RightPanel.Phase.RoomMemberInfo && member.roomId === this.props.roomId && member.userId === this.state.member.userId) {
                // refresh the member info (e.g. new power level)
                this._delayedUpdate();
            }
        }
    }, {
        key: 'onAction',
        value: function onAction(payload) {
            if (payload.action === "view_right_panel_phase") {
                this.setState({
                    phase: payload.phase,
                    groupRoomId: payload.groupRoomId,
                    groupId: payload.groupId,
                    member: payload.member,
                    event: payload.event
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var MemberList = _index2.default.getComponent('rooms.MemberList');
            var MemberInfo = _index2.default.getComponent('rooms.MemberInfo');
            var ThirdPartyMemberInfo = _index2.default.getComponent('rooms.ThirdPartyMemberInfo');
            var NotificationPanel = _index2.default.getComponent('structures.NotificationPanel');
            var FilePanel = _index2.default.getComponent('structures.FilePanel');

            var GroupMemberList = _index2.default.getComponent('groups.GroupMemberList');
            var GroupMemberInfo = _index2.default.getComponent('groups.GroupMemberInfo');
            var GroupRoomList = _index2.default.getComponent('groups.GroupRoomList');
            var GroupRoomInfo = _index2.default.getComponent('groups.GroupRoomInfo');

            var panel = _react2.default.createElement('div', null);

            if (this.props.roomId && this.state.phase === RightPanel.Phase.RoomMemberList) {
                panel = _react2.default.createElement(MemberList, { roomId: this.props.roomId, key: this.props.roomId });
            } else if (this.props.groupId && this.state.phase === RightPanel.Phase.GroupMemberList) {
                panel = _react2.default.createElement(GroupMemberList, { groupId: this.props.groupId, key: this.props.groupId });
            } else if (this.state.phase === RightPanel.Phase.GroupRoomList) {
                panel = _react2.default.createElement(GroupRoomList, { groupId: this.props.groupId, key: this.props.groupId });
            } else if (this.state.phase === RightPanel.Phase.RoomMemberInfo) {
                panel = _react2.default.createElement(MemberInfo, { member: this.state.member, key: this.props.roomId || this.state.member.userId });
            } else if (this.state.phase === RightPanel.Phase.Room3pidMemberInfo) {
                panel = _react2.default.createElement(ThirdPartyMemberInfo, { event: this.state.event, key: this.props.roomId });
            } else if (this.state.phase === RightPanel.Phase.GroupMemberInfo) {
                panel = _react2.default.createElement(GroupMemberInfo, {
                    groupMember: this.state.member,
                    groupId: this.props.groupId,
                    key: this.state.member.user_id });
            } else if (this.state.phase === RightPanel.Phase.GroupRoomInfo) {
                panel = _react2.default.createElement(GroupRoomInfo, {
                    groupRoomId: this.state.groupRoomId,
                    groupId: this.props.groupId,
                    key: this.state.groupRoomId });
            } else if (this.state.phase === RightPanel.Phase.NotificationPanel) {
                panel = _react2.default.createElement(NotificationPanel, null);
            } else if (this.state.phase === RightPanel.Phase.FilePanel) {
                panel = _react2.default.createElement(FilePanel, { roomId: this.props.roomId, resizeNotifier: this.props.resizeNotifier });
            }

            var classes = (0, _classnames2.default)("mx_RightPanel", "mx_fadable", {
                "collapsed": this.props.collapsed,
                "mx_fadable_faded": this.props.disabled,
                "dark-panel": true
            });

            return _react2.default.createElement(
                'aside',
                { className: classes },
                panel
            );
        }
    }]);
    return RightPanel;
}(_react2.default.Component); /*
                              Copyright 2015, 2016 OpenMarket Ltd
                              Copyright 2017 Vector Creations Ltd
                              Copyright 2017 New Vector Ltd
                              Copyright 2018 New Vector Ltd
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

RightPanel.Phase = (0, _freeze2.default)({
    RoomMemberList: 'RoomMemberList',
    GroupMemberList: 'GroupMemberList',
    GroupRoomList: 'GroupRoomList',
    GroupRoomInfo: 'GroupRoomInfo',
    FilePanel: 'FilePanel',
    NotificationPanel: 'NotificationPanel',
    RoomMemberInfo: 'RoomMemberInfo',
    Room3pidMemberInfo: 'Room3pidMemberInfo',
    GroupMemberInfo: 'GroupMemberInfo'
});
exports.default = RightPanel;
module.exports = exports['default'];
//# sourceMappingURL=RightPanel.js.map